import BrokerMultiSelect, { Broker } from "../../../components/BrokerMultiSelect";
import { LeadStatus } from "../../../types/onboarding";

const LABEL: Record<LeadStatus, string> = {
  insurer_review: "Insurer",
  docs_pending: "Docs",
  signature_pending: "Signature",
  ops_review: "Ops",
  it_review: "IT",
  csv_pending: "CSV",
  legalnote_pending: "Legal note",
  payment_validation_pending: "Payment val.",
  ready_to_send: "Ready to send",
  complete: "Complete",
  canceled: "Canceled",
  claim: "Claim",
};

type Props = {
  search: string;
  onSearch: (value: string) => void;
  availableStatuses: readonly LeadStatus[];
  selectedStatuses: LeadStatus[];
  onToggleStatus: (status: LeadStatus) => void;
  carrier: string;
  onCarrierChange: (value: string) => void;
  carriers: string[];
  brokers: Broker[];
  selectedBrokerIds: number[];
  onSelectedBrokerIdsChange: (next: number[]) => void;
  brokersLoading: boolean;
  total: number;
  visible: number;
};

export default function FiltersBar({
  search,
  onSearch,
  availableStatuses,
  selectedStatuses,
  onToggleStatus,
  carrier,
  onCarrierChange,
  carriers,
  brokers,
  selectedBrokerIds,
  onSelectedBrokerIdsChange,
  brokersLoading,
  total,
  visible,
}: Props) {
  return (
    <div
      style={{
        background: "white",
        padding: "1rem 1.25rem",
        borderRadius: "0.6rem",
        boxShadow: "0 1px 3px rgba(0,0,0,.04)",
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        alignItems: "center",
        marginBottom: "1rem",
      }}
    >
      <input
        type="search"
        placeholder="Buscar lead_id, email, DNI, póliza…"
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        style={{ flex: "1 1 260px", minWidth: 240 }}
      />

      <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap" }}>
        {availableStatuses.map((s) => {
          const active = selectedStatuses.includes(s);
          return (
            <button
              key={s}
              type="button"
              onClick={() => onToggleStatus(s)}
              style={{
                padding: "0.35rem 0.7rem",
                borderRadius: "999px",
                border: active ? "1px solid #0069d9" : "1px solid #dee2e6",
                background: active ? "#0069d9" : "white",
                color: active ? "white" : "#1f2933",
                fontSize: ".75rem",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              {LABEL[s] ?? s}
            </button>
          );
        })}
      </div>

      <select
        value={carrier}
        onChange={(e) => onCarrierChange(e.target.value)}
        style={{ minWidth: 140 }}
      >
        <option value="">Todas las carriers</option>
        {carriers.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <BrokerMultiSelect
        brokers={brokers}
        selectedIds={selectedBrokerIds}
        onChange={onSelectedBrokerIdsChange}
        loading={brokersLoading}
      />

      <div
        style={{
          marginLeft: "auto",
          fontSize: ".8rem",
          color: "#73879C",
        }}
      >
        {visible} de {total}
      </div>
    </div>
  );
}
